var CollectionPage = function(template, collections, selector) {
  var pushIfNotFound = function(el, list) {
    if (!list.includes(el)) {
      list.push(el);
    }
  };
  var isMobile = function() {
    return $(window).width() < 768;
  };

  this.sel = (function(selector) {
    return $(this.SELECTOR + (selector ? (' ' + selector) : ''));
  }).bind(this);

  this.isQuickAddCollection = (function() {
    return this.COLLECTION.handle !== 'the-merch'
  }).bind(this);

  this.initGlobalState = function(models) {
    if (!window.COOKIES.get('expandedSubCollections')) {
      window.COOKIES.set('expandedSubCollections', {'original': ['Gym Shorts']});
    }
  };

  this.buildModel = (function(models) {
    var buildCollection = function(collection) {
      if (!collection) {
        return {};
      }
      switch(collection.handle) {
        case 'preorders':
          collection.header_class = 'presales';
          collection.page_title = 'preorders';
          break;
        case 'the-merch':
          collection.header_class = 'the-merch';
          collection.page_title = 'free with multi pair orders';
          break;
        case 'gym-pants':
        case 'pants':
          collection.header_class = 'gym-pants';
          collection.page_title = 'Pants';
          break;
        case 'stretch-khakis':
        case 'khaki-pants':
        case 'joggers':
        case 'sweatpants':
        case 'classic-sweatpants':
        case 'silky-sweatpants':
          collection.header_class = 'gym-pants';
          collection.page_title = collection.title;
          break;
        case 'rare-birddogs':
          collection.header_class = 'rare-birddogs';
          collection.page_title = 'Rare birddogs';
          break;
        case 'boxer-briefs':
          collection.header_class = 'boxer-briefs';
          collection.page_title = 'Boxer Briefs';
          break;
        case 'polos':
          collection.header_class = 'polos';
          collection.page_title = 'Polos';
          break;
        default:
          collection.header_class = 'default';
          collection.page_title = collection.title;
          break;
      }
      if (collection.handle !== 'preorders') {
        collection.products = collection.products.filter(function(product) {
          return !product.tags.includes('preorder');
        });
      }
      if (collection.header_class === 'default' && !collection.handle.includes('test')) {
        collection.sub_collections = [
          {
            tag_filter: 'original',
            product_line_name: 'Gym Shorts',
          },
          {
            tag_filter: 'khaki',
            product_line_name: 'Khaki Shorts',
          },
          {
            tag_filter: 'oxford',
            product_line_name: 'Oxford Shorts',
          },
          {
            tag_filter: 'seersucker',
            product_line_name: 'Seersucker Shorts',
          },
          {
            tag_filter: 'bathing-suit',
            product_line_name: 'Bathing Suit',
          },
          {
            tag_filter: 'golf-shorts',
            product_line_name: 'Golf Shorts',
            hidden: true
          },
        ];
        if (collection.handle === 'shorts') {
          collection.sub_collections = collection.sub_collections.filter(
            function(subCollection) {
              return !subCollection.hidden;
            }
          );
        } else {
          collection.sub_collections = collection.sub_collections.filter(
            function(subCollection) {
              return subCollection.tag_filter === collection.handle
            }
          );
        }
        collection.sub_collections.forEach(function(subCollection) {
          subCollection.product_type = 'gym-shorts';
          subCollection.products = collection.products.filter(function(product) {
            return product.tags.includes(subCollection.tag_filter);
          });
        });
      } else if (collection.header_class === 'gym-pants' && !collection.handle.includes('test')) {
        collection.sub_collections = [
          {
            tag_filter: 'khaki-pants',
            product_line_name: 'Stretch Khakis',
          },
          {
            tag_filter: 'joggers',
            product_line_name: 'Joggers',
          },
          {
            tag_filter: 'classic-sweatpants',
            product_line_name: 'Classic Cotton Sweats',
            collection_link: 'sweatpants',
          },
          {
            tag_filter: 'silky-sweatpants',
            product_line_name: 'Silky Soft Sweatpants',
            collection_link: 'sweatpants',
          },
        ];
        if (collection.handle !== 'pants' && collection.handle !== 'sweatpants') {
          collection.sub_collections = collection.sub_collections.filter(
            function(subCollection) {
              return subCollection.tag_filter === collection.handle
            }
          );
        }
        collection.sub_collections.forEach(function(subCollection) {
          subCollection.product_type = 'gym-pants';
          subCollection.products = collection.products.filter(function(product) {
            return product.tags.includes(subCollection.tag_filter);
          });
          // subCollection.products.sort(function(el1, el2) {
          //   if (el1.title === 'Ernie Musks') {
          //     return -1;
          //   } else if (el2.title === 'Ernie Musks') {
          //     return 1;
          //   } else {
          //     return 0;
          //   }
          // });
        });
        // console.log({collection: collection});
      } else if (collection.header_class === 'boxer-briefs' && !collection.handle.includes('test')) {
        collection.sub_collections = [
          {
            tag_filter: 'boxer-briefs',
            product_line_name: 'Boxer Briefs',
            product_type: 'boxer-briefs',
            products: collection.products
          }
        ];
      } else if (collection.header_class === 'polos' && !collection.handle.includes('test')) {
        collection.sub_collections = [
          {
            tag_filter: 'polos',
            product_line_name: 'Polos',
            product_type: 'polos',
            products: collection.products
          }
        ];
      } else {
        collection.sub_collections = [{
          product_type: collection.header_class,
          tag_filter: '',
          product_line_name: collection.page_title,
          products: collection.products
        }];
      }
      collection.products.forEach(function(product) {
        product.price_min = '' + (product.price_min / 100).toFixed(0);
        product.featured_image = product.collection_image;
        product.featured_image_hover = product.collection_image_hover;
      });
      var expandedSubCollections = window.COOKIES.get('expandedSubCollections');
      collection.sub_collections.forEach(function(subCollection) {
        if (models.customFields[subCollection.tag_filter]) {
          subCollection.product_line_description =
              models.customFields[subCollection.tag_filter].product_line_description;
        }
        if (!subCollection.collection_link && subCollection.tag_filter) {
          subCollection.collection_link = subCollection.tag_filter;
        }
        if (expandedSubCollections && expandedSubCollections[models.handle] &&
            expandedSubCollections[models.handle].includes(subCollection.product_line_name)) {
          subCollection.expanded = true;
        }
      });
      return collection;
    };
    this.initGlobalState(models);
    var collections = {
      main: buildCollection(models.collections[models.handle])
    };
    if (models.handle !== 'rare-birddogs') {
      collections.rareBirddogs = buildCollection(models.collections['rare-birddogs']);
    }

    var filterOptions = {};

    collections.main.products.forEach(function(product) {
      product.options.forEach(function(option) {
        if (!filterOptions[option] && option !== 'Liner') {
          filterOptions[option] = [];
        }
      });
      product.variants.forEach(function(variation) {
        variation.filterProperties = {};
        ['option1', 'option2', 'option3'].forEach(function(optionName, i) {
          if (!variation[optionName]) {
            return;
          }
          var option = variation[optionName].toLowerCase();
          if (option.includes('liner')) {
            return;
          }
          variation.filterProperties[product.options[i].toLowerCase().split(' ')[0]] = option;
          pushIfNotFound(option, filterOptions[product.options[i]]);
        });
      });
    });
    filterOptions = Object.keys(filterOptions)
      .filter(function(option) {
        return filterOptions[option].length;
      })
      .reduce(function(res, key) {
        res[key] = filterOptions[key];
        return res;
      }, {});
    var valuesIndex = {
      'small': 'S',
      'medium': 'M',
      'large': 'L',
      'xl': 'XL',
      'xxl': 'XXL',
      '3xl': '3XL',
      'xxxl': '3XL',
      'short: 5"': 'Short 5&quot;',
      'short: 6"': 'Short 6&quot;',
      'classic: 7"': 'Regular 7&quot;',
      'long: 9 1/4"': 'Long 9&quot;',
      'long: 9"': 'Long 9&quot;'
    };
    var hiddenFilters = {
      'Waist': ['31', '33', '40']
    };
    var filters = {};
    filters.filterOptions = Object.keys(filterOptions).map(function(optionType, optionIndex) {
      if (hiddenFilters[optionType]) {
        filterOptions[optionType] = filterOptions[optionType].filter(function(option) {
          return !hiddenFilters[optionType].includes(option);
        });
      }
      var optionTitle = optionType.toLowerCase().split(' ')[0];
      return {
        title: optionTitle,
        options: filterOptions[optionType].map(function(option) {
          return {
            class_name: optionTitle + '-' + option.toLowerCase().split(/[\: ]/g)[0].replace('$', ''),
            value: option,
            label: valuesIndex[option] || option
          }
        })
      };
    });
    return {
      collections: collections,
      filters: filters
    };
  }).bind(this);

  this.updateModel = (function() {
    this.COLLECTION.num_visible_products = 0;
    this.FILTERS.has_filter = Object.values(this.SELECTED_FILTERS).some(
      (function(optionValues) {
        return optionValues && optionValues.length > 0;
      }).bind(this)
    );
    this.COLLECTION.sub_collections.forEach((function(subCollection) {
      var productsList = subCollection.products.slice();
      if (this.FILTERS.has_filter && this.RARE_BIRDDOGS && this.RARE_BIRDDOGS.products) {
        this.RARE_BIRDDOGS.products.forEach(function(product) {
          if (product.tags && product.tags.includes(subCollection.tag_filter)) {
            productsList.push(product);
          }
        });
      }
      subCollection.visible_products = productsList.filter(
        (function(product) {
          var variants = product.variants;
          if (product.preorder_product && product.preorder_product.variants) {
            variants = variants.concat(product.preorder_product.variants);
          }
          var availableVariants = variants.filter(function(variant) {
            return variant.available;
          });
          Object.keys(this.SELECTED_FILTERS).forEach(
            (function(optionName) {
              if (this.SELECTED_FILTERS[optionName].length === 0) {
                return;
              }
              availableVariants = availableVariants.filter(
                (function(variant) {
                  return variant.filterProperties && (!variant.filterProperties[optionName] || this.SELECTED_FILTERS[optionName].includes(variant.filterProperties[optionName]));
                }).bind(this))
            }).bind(this));
            
          return availableVariants.length > 0;
        }).bind(this));
      this.COLLECTION.num_visible_products += subCollection.visible_products.length;
    }).bind(this));
  }).bind(this);

  this.addEvents = (function() {
    var addProductEvents = (function(product) {
      var formToggle = (function(mobileTrigger, forceOnOrOff) {
        return (function(e) {
          if (!Templates || !Templates.loaded ||
              !this.isQuickAddCollection() ||
              (isMobile() && !mobileTrigger) ||
              (!isMobile() && mobileTrigger) ||
              (e && e.type === 'mouseenter' &&
                  $(e.target).closest('.quick-add-expanded').length) ||
              (!product.available &&
                  (!product.preorder_product || !product.preorder_product.available))) {
            return false;
          }
          var toggleOn = forceOnOrOff === true ||
              (forceOnOrOff === undefined && !$('#collections-page-item-' + product.id).is('.quick-add-expanded'))
          if (!toggleOn) {
            $('#collections-page-item-' + product.id + ' .form-container .collections-page-item-quick-add').html(
              Templates.getTemplate('QuickAddForm')({
                product: product,
                is_expanded: false
              }));
            $('#collections-page-item-' + product.id).removeClass('quick-add-expanded');
            if ($('#collections-page-item-' + product.id + ' .expanded-image').length) {
              $('#collections-page-item-' + product.id + ' .expanded-image').addClass('hidden-expanded-image');
              $('#collections-page-item-' + product.id + ' .unexpanded-image').removeClass('hidden-expanded-image');
            }
          } else {
            var existingQuickAdd = $('.quick-add-expanded');
            if (existingQuickAdd.length) {
              if (!isMobile()) {
                existingQuickAdd.find('.collections-page-item-quick-add').html('');
                existingQuickAdd.removeClass('quick-add-expanded');
              }
            }
            var form = new ProductForm(
              Templates.getTemplate('QuickAddForm'),
              product,
              '#collections-page-item-' + product.id + ' .form-container .collections-page-item-quick-add',
              formToggle(mobileTrigger, false)
            );
            form.render();
            $('#collections-page-item-' + product.id).addClass('quick-add-expanded');
            if ($('#collections-page-item-' + product.id + ' .expanded-image').length) {
              $('#collections-page-item-' + product.id + ' .expanded-image').removeClass('hidden-expanded-image');
              $('#collections-page-item-' + product.id + ' .unexpanded-image').addClass('hidden-expanded-image');
            }
          }
          $('#collections-page-item-' + product.id + ' .collections-page-item-quick-add-title').click(
            formToggle(true)
          );
          var section = $('#collections-page-item-' + product.id)
              .closest('.collections-page-section');
          if (section.find('.quick-add-expanded').length > 0) {
            section.addClass('collections-page-section-expanded');

          } else {
            section.removeClass('collections-page-section-expanded');
          }
        }).bind(this);
      }).bind(this);
      $('#collections-page-item-' + product.id + ' .collections-page-item-quick-add-title').click(
        formToggle(true)
      );
      $('#collections-page-item-' + product.id + ' .form-container').mouseenter(
        formToggle(false, true)
      );
      $('#collections-page-item-' + product.id + ' .form-container').mouseleave(
        formToggle(false, false)
      );
    }).bind(this);
    this.COLLECTION.products.forEach(addProductEvents);
    if (this.RARE_BIRDDOGS && this.RARE_BIRDDOGS.products) {
      this.RARE_BIRDDOGS.products.forEach(addProductEvents);
    }
    this.FILTERS.filterOptions.forEach((function(filter) {
      filter.options.forEach((function(option) {
        $('#product-filter-' + option.class_name).click(this.sideEffect(function() {
          if (!this.SELECTED_FILTERS[filter.title]) {
            this.SELECTED_FILTERS[filter.title] = [];
          }
          var existingFilterIndex = this.SELECTED_FILTERS[filter.title].indexOf(option.value);
          if (existingFilterIndex < 0) {
            this.SELECTED_FILTERS[filter.title].push(option.value);

          } else {
            this.SELECTED_FILTERS[filter.title].splice(existingFilterIndex, 1);
          }
        }));
      }).bind(this));
    }).bind(this));
    $('.collections-page-item-thumbs').click(this.sideEffect(function(e) {
      var handle = $(e.target).closest('.collections-page-item-thumbs').data('collectionHandle');
      var sub;
      if (handle) {
        sub = this.COLLECTION.sub_collections.find(function(sub) {
          return sub.tag_filter === handle;
        });
      } else {
        sub = this.COLLECTION.sub_collections[0];
      }
      sub.expanded = true;
      var expandedSubCollections = window.COOKIES.get('expandedSubCollections');
      if (!expandedSubCollections) {
        expandedSubCollections = {};
      }
      if (!expandedSubCollections[this.COLLECTION.handle]) {
        expandedSubCollections[this.COLLECTION.handle] = [];
      }
      if (!expandedSubCollections[this.COLLECTION.handle].includes(sub.product_line_name)) {
        expandedSubCollections[this.COLLECTION.handle].push(sub.product_line_name);
      }
      window.COOKIES.set('expandedSubCollections', expandedSubCollections);
    }));
    $('.product-filter__title a.activator-link').click(this.sideEffect(function(e) {
      this.FILTERS.expanded = !this.FILTERS.expanded;
      return false;
    }));
    $('.action-apply, .filter-mask').click(this.sideEffect(function() {
      this.FILTERS.mobile_expanded = false;
    }));
    $('.action-clear').click(this.sideEffect(function(e) {
      e.preventDefault();
      this.SELECTED_FILTERS = {};
      return false;
    }));
  }).bind(this);


  this.sideEffect = (function(fn) {
    return (function(e) {
      var eax = fn.bind(this)(e);
      this.render();
      return eax;
    }).bind(this)
  }).bind(this);

  this.render = (function() {
    this.updateModel();
    var rendered = this._TEMPLATE({
      collection: this.COLLECTION,
      filters: this.FILTERS,
      selected_filters: this.SELECTED_FILTERS
    });
    this.sel().html(rendered);
    this.addEvents();
    
  }).bind(this);

  var model = this.buildModel(collections);
  this._TEMPLATE = template;
  this.COLLECTION = model.collections.main;
  this.RARE_BIRDDOGS = model.collections.rareBirddogs;
  this.FILTERS = model.filters;
  this.SELECTOR = selector;

  this.SELECTED_FILTERS = {};
};
